import { render, staticRenderFns } from "./BoletimMedicaoNovo.vue?vue&type=template&id=753e179e&"
import script from "./BoletimMedicaoNovo.vue?vue&type=script&lang=js&"
export * from "./BoletimMedicaoNovo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports